import * as yup from 'yup';
import { validateSwedishPostalCode } from './swedish-postal-code';
import { validateCity } from './city';
import { validateSwedishSsn } from './swedish-ssn';
import { validatePhoneNumber } from './phone-number';

export const validatePerson = {
  firstName: yup
    .string()
    .nullable()
    .trim()
    .required('Förnamn krävs')
    .matches(/^[^\d]+$/, 'Förnamn får inte innehålla siffror'),
  lastName: yup
    .string()
    .trim()
    .required('Efternamn krävs')
    .matches(/^[^\d]+$/, 'Efternamnet får inte innehålla siffror'),
  socialSecurityNumber: validateSwedishSsn(true),
  address: yup.string().nullable().trim().required('Utdelningsadress krävs'),
  postalCode: validateSwedishPostalCode(true),
  city: validateCity,
  phoneNumber: validatePhoneNumber.required('Telefon krävs'),
};

export const validateSignerPerson = {
  fullName: yup
    .string()
    .nullable()
    .trim()
    .required('Namn krävs') // TODO check swedish
    .matches(/^[^\d]+$/, 'Namng får inte innehålla siffror'),
};
